(async () => {
  await customElements.whenDefined('shopify-account');
  const accountEl = document.querySelector('shopify-account');
  if (!accountEl?.shadowRoot) return;

  const shadowRoot = accountEl.shadowRoot;

  function injectExtranetButton() {
    if (shadowRoot.querySelector('.extranet-btn-wrapper')) return;

    const container = shadowRoot.querySelector('dialog, [popover]');
    if (!container) return;

    const style = document.createElement('style');
    style.textContent = `
      .extranet-btn-wrapper {
        padding: 0 16px 16px;
        margin-top: 4px;
      }
      .extranet-btn {
        display: block;
        width: 100%;
        padding: 20px;
        text-align: center;
        border: 1px solid currentColor;
        border-radius: var(--buttons-radius, 4px);
        text-decoration: none;
        font-size: var(--font-size-static-small, 14px);
        font-family: inherit;
        font-weight: inherit;
        background: transparent;
        color: inherit;
        cursor: pointer;
        box-sizing: border-box;
        transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
      }
      .extranet-btn:hover,
      .extranet-btn:focus-visible {
        background: #000;
        color: #fff;
        border-color: #000;
      }
      .extranet-btn:hover .extranet-btn__highlight,
      .extranet-btn:focus-visible .extranet-btn__highlight {
        color: #fff;
      }
      .extranet-btn__highlight {
        color: #e9332b;
      }
    `;
    shadowRoot.appendChild(style);

    const i18nEl = document.getElementById('extranet-btn-i18n');
    const prefix = i18nEl?.dataset.extranetPrefix ?? '';

    const wrapper = document.createElement('div');
    wrapper.className = 'extranet-btn-wrapper';
    const a = document.createElement('a');
    a.href = 'https://extranet.etnia.es/';
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.className = 'extranet-btn';
    a.append(prefix);
    const highlight = document.createElement('span');
    highlight.className = 'extranet-btn__highlight';
    highlight.textContent = 'Extranet';
    a.appendChild(highlight);
    wrapper.appendChild(a);

    container.appendChild(wrapper);
  }

  injectExtranetButton();

  new MutationObserver(injectExtranetButton).observe(shadowRoot, {
    childList: true,
    subtree: true,
  });
})();
